<samweb-loading-indicator
   [showForAllLongRunningContextCategories]="!isPilotPanel"
   [indicatorOnTop]="false"
   [runForever]="false"
>
   <div class="brick-wall-container">
      <gridster [options]="options">
         <gridster-item
            *ngFor="let brickId of brickInstanceIds$ | async"
            [item]="brickId | brickIdToGridsterConfig$ | async"
            [ngClass]="{
               stage: (brickId | instanceIdToBrickDescription$ | async).brickInstance.brickDefinitionId === 'stageBrick'
            }"
         >
            <samweb-brick-container [brickInstanceId]="brickId"></samweb-brick-container>
         </gridster-item>
      </gridster>
   </div>
</samweb-loading-indicator>
